import { combineReducers } from 'redux';

import productCurrency from 'src/app/v1/state/modules/session/productCurrency';

import { default as adBudget } from './adBudget';
import { default as advertiserId } from './advertiserId';
import { default as advertiserName } from './advertiserName';
import { default as billToAgent } from './billToAgent';
import { default as billingAccountId } from './billingAccountId';
import { default as buyUpSell } from './buyUpSell';
import { default as cart } from './cart';
import { default as categoryText } from './categoryText';
import { default as contractBalance } from './contractBalance';
import { default as createJobAndOrderRequest } from './createJobAndOrderRequest';
import { default as createProductSetRequest } from './createProductSetRequest';
import { default as draftId } from './draftId';
import { default as draftStatus } from './draftStatus';
import { default as editFlowCheckout } from './editFlowCheckout';
import { default as hasReviewedGeneratedContent } from './hasReviewedGeneratedContent';
import { default as hirerAccount } from './hirerAccount';
import { default as hirerIsNew } from './hirerIsNew';
import { default as interactionId } from './interactionId';
import { default as isEmailVerified } from './isEmailVerified';
import { default as isJobPosted } from './isJobPosted';
import { default as isJobPostedEventPublished } from './isJobPostedEventPublished';
import { default as isPaymentInProgress } from './isPaymentInProgress';
import { default as job } from './job';
import { default as jobLocationCountry } from './jobLocationCountry';
import { default as jobLocationDisplayDescription } from './jobLocationDisplayDescription';
import { default as jobLocationText } from './jobLocationText';
import { default as jobOrderId } from './jobOrderId';
import { default as notificationsSetting } from './notificationsSetting';
import { default as pageId } from './pageId';
import { default as paymentType } from './paymentType';
import { default as phoneNumber } from './phoneNumber';
import { default as postChannel } from './postChannel';
import { default as postType } from './postType';
import { default as postalAddress } from './postalAddress';
import { default as productCode } from './productCode';
import { default as productDisplayName } from './productDisplayName';
import { default as productFeatures } from './productFeatures';
import { default as productSet } from './productSet';
import { default as productSetStatus } from './productSetStatus';
import { default as rrFailedToSave } from './rrFailedToSave';
import { default as seekAdvertiserId } from './seekAdvertiserId';
import { default as seekClassificationId } from './seekClassificationId';
import { default as seekSubClassificationId } from './seekSubClassificationId';
import { default as selectedRRQuestions } from './selectedRRQuestions';
import { default as sourceJobId } from './sourceJobId';
import { default as subCategoryText } from './subCategoryText';
import { default as userCanManageUsers } from './userCanManageUsers';
import { default as userCanPayInvoices } from './userCanPayInvoices';
import { default as userEmailAddress } from './userEmailAddress';
import { default as userFirstName } from './userFirstName';
import { default as userId } from './userId';
import { default as userLastName } from './userLastName';
import { default as userPermissions } from './userPermissions';

export default combineReducers({
  adBudget,
  advertiserId,
  advertiserName,
  billToAgent,
  billingAccountId,
  buyUpSell,
  cart,
  categoryText,
  contractBalance,
  createJobAndOrderRequest,
  createProductSetRequest,
  draftId,
  draftStatus,
  editFlowCheckout,
  hasReviewedGeneratedContent,
  hirerAccount,
  hirerIsNew,
  interactionId,
  isEmailVerified,
  isJobPosted,
  isJobPostedEventPublished,
  isPaymentInProgress,
  job,
  jobLocationCountry,
  jobLocationDisplayDescription,
  jobLocationText,
  jobOrderId,
  notificationsSetting,
  pageId,
  paymentType,
  phoneNumber,
  postChannel,
  postType,
  postalAddress,
  productCode,
  productCurrency,
  productDisplayName,
  productSet,
  productSetStatus,
  rrFailedToSave,
  seekAdvertiserId,
  seekClassificationId,
  seekSubClassificationId,
  productFeatures,
  selectedRRQuestions,
  sourceJobId,
  subCategoryText,
  userCanManageUsers,
  userCanPayInvoices,
  userEmailAddress,
  userFirstName,
  userLastName,
  userId,
  userPermissions,
});
